export const VENDOR_CONTRACT_STATUS = {
  Active: { label: 'Active', color: '#059669', bg: '#ECFDF5', ring: '#A7F3D0' },
  'Under Review': { label: 'Under Review', color: '#D97706', bg: '#FFFBEB', ring: '#FDE68A' },
  Expired: { label: 'Expired', color: '#DC2626', bg: '#FEF2F2', ring: '#FECACA' },
};

export const TRANSPORT_VENDORS = [
  {
    vendorId: 'VND-786',
    companyName: 'Falcon Fuel Transport',
    totalFleets: 18,
    contractStatus: 'Active',
    pendingInvoices: 124500,
    contactPhone: '+971 4 338 2100',
    emirate: 'Dubai',
    fleetDeployment: [
      {
        tankerId: 'TNK-FF-001',
        plate: 'A 48291',
        status: 'In Transit',
        route: 'Ruwais Refinery → Jebel Ali Terminal',
        cargo: 'Diesel ULSD',
        driver: 'Ahmed Al Mansoori',
        eta: '14 Jun 2026 · 18:30',
      },
      {
        tankerId: 'TNK-FF-002',
        plate: 'B 77102',
        status: 'Loading',
        route: 'Hamriyah Port → Fujairah Depot',
        cargo: 'Jet Fuel A-1',
        driver: 'Mohammed Hassan',
        eta: '14 Jun 2026 · 21:00',
      },
      {
        tankerId: 'TNK-FF-003',
        plate: 'C 11984',
        status: 'Idle · Yard',
        route: 'JAFZA Logistics Yard',
        cargo: '—',
        driver: 'Unassigned',
        eta: '—',
      },
      {
        tankerId: 'TNK-FF-004',
        plate: 'A 55023',
        status: 'In Transit',
        route: 'Musaffah → Dubai Silicon Oasis',
        cargo: 'LPG Bulk',
        driver: 'Vikram Singh',
        eta: '15 Jun 2026 · 06:15',
      },
    ],
  },
  {
    vendorId: 'VND-442',
    companyName: 'Gulf Logistics',
    totalFleets: 24,
    contractStatus: 'Active',
    pendingInvoices: 89200,
    contactPhone: '+971 2 678 4400',
    emirate: 'Abu Dhabi',
    fleetDeployment: [
      {
        tankerId: 'TNK-GL-101',
        plate: 'AD 8821',
        status: 'In Transit',
        route: 'Habshan → Mussafah ICAD',
        cargo: 'Crude Oil',
        driver: 'Khalid Al Zaabi',
        eta: '14 Jun 2026 · 16:45',
      },
      {
        tankerId: 'TNK-GL-102',
        plate: 'AD 9934',
        status: 'Maintenance',
        route: 'Workshop · Mussafah M-12',
        cargo: '—',
        driver: '—',
        eta: 'Return 17 Jun 2026',
      },
      {
        tankerId: 'TNK-GL-103',
        plate: 'AD 4412',
        status: 'Dispatched',
        route: 'Ruwais → Al Dhafra Base',
        cargo: 'Gas Oil',
        driver: 'Sanjay Patel',
        eta: '14 Jun 2026 · 20:00',
      },
    ],
  },
  {
    vendorId: 'VND-319',
    companyName: 'Emirates Tanker Services',
    totalFleets: 12,
    contractStatus: 'Under Review',
    pendingInvoices: 45800,
    contactPhone: '+971 6 543 8800',
    emirate: 'Sharjah',
    fleetDeployment: [
      {
        tankerId: 'TNK-ET-201',
        plate: 'SH 2201',
        status: 'Idle · Yard',
        route: 'Sharjah Industrial Area',
        cargo: '—',
        driver: 'Unassigned',
        eta: '—',
      },
      {
        tankerId: 'TNK-ET-202',
        plate: 'SH 2202',
        status: 'Standby',
        route: 'Awaiting contract renewal',
        cargo: '—',
        driver: 'Rashid Omar',
        eta: '—',
      },
    ],
  },
  {
    vendorId: 'VND-105',
    companyName: 'Ruwais Heavy Haulage LLC',
    totalFleets: 9,
    contractStatus: 'Active',
    pendingInvoices: 67300,
    contactPhone: '+971 2 801 9900',
    emirate: 'Abu Dhabi',
    fleetDeployment: [
      {
        tankerId: 'TNK-RH-301',
        plate: 'AU 5501',
        status: 'In Transit',
        route: 'Fujairah Port → Ruwais',
        cargo: 'Bitumen 80/100',
        driver: 'Yusuf Ibrahim',
        eta: '15 Jun 2026 · 04:30',
      },
      {
        tankerId: 'TNK-RH-302',
        plate: 'AU 5502',
        status: 'Loading',
        route: 'Ruwais → Jebel Ali',
        cargo: 'Chemical ADR Class 3',
        driver: 'Imran Khan',
        eta: '14 Jun 2026 · 22:15',
      },
    ],
  },
  {
    vendorId: 'VND-028',
    companyName: 'Desert Star Fuel Carriers',
    totalFleets: 6,
    contractStatus: 'Expired',
    pendingInvoices: 22100,
    contactPhone: '+971 4 881 7700',
    emirate: 'Dubai',
    fleetDeployment: [
      {
        tankerId: 'TNK-DS-401',
        plate: 'D 99001',
        status: 'Grounded',
        route: 'Contract expired · Off dispatch',
        cargo: '—',
        driver: '—',
        eta: '—',
      },
    ],
  },
  {
    vendorId: 'VND-651',
    companyName: 'Al Noor Petroleum Logistics',
    totalFleets: 15,
    contractStatus: 'Active',
    pendingInvoices: 103400,
    contactPhone: '+971 4 295 6600',
    emirate: 'Dubai',
    fleetDeployment: [
      {
        tankerId: 'TNK-AN-501',
        plate: 'D 11234',
        status: 'In Transit',
        route: 'Jebel Ali → DIC Depot',
        cargo: 'Diesel EN590',
        driver: 'Tariq Mahmoud',
        eta: '14 Jun 2026 · 17:00',
      },
      {
        tankerId: 'TNK-AN-502',
        plate: 'D 11235',
        status: 'In Transit',
        route: 'Ruwais → Fujairah',
        cargo: 'Gas Oil',
        driver: 'Ali Reza',
        eta: '15 Jun 2026 · 08:00',
      },
      {
        tankerId: 'TNK-AN-503',
        plate: 'D 11236',
        status: 'Dispatched',
        route: 'Hamriyah → Al Ain',
        cargo: 'LPG',
        driver: 'Faisal Nasser',
        eta: '14 Jun 2026 · 23:30',
      },
    ],
  },
];
